import {
  DatePicker as ArkUiDatePicker,
  UseDatePickerContext,
} from "@ark-ui/react";
import Button from "../../Button/Button";
import Icon from "../../Icon/Icon";
import { Text } from "../../typography/Text";
import { AromaDatepickerRecipe } from "@zenchef/styled-system/recipes";
import { Translations } from "./types";

interface Props {
  classes: ReturnType<AromaDatepickerRecipe>;
  datePicker: UseDatePickerContext;
  withDoubleArrows?: boolean;
  translations: Translations;
}

export default function Header({
  classes,
  datePicker,
  withDoubleArrows,
  translations,
}: Props) {
  return (
    <ArkUiDatePicker.ViewControl className={classes.header}>
      {withDoubleArrows ? (
        <ArkUiDatePicker.PrevTrigger asChild>
          <Button
            iconOnly
            hierarchy="secondary-subtle"
            onClick={(event) => {
              datePicker.focusYear(datePicker.focusedValue.year - 1);
              // prevent substracting one month
              event.preventDefault();
            }}
          >
            <Icon name="chevron-left-double" />
          </Button>
        </ArkUiDatePicker.PrevTrigger>
      ) : null}
      <ArkUiDatePicker.PrevTrigger asChild>
        <Button iconOnly hierarchy="secondary-subtle">
          <Icon name="chevron-left" />
        </Button>
      </ArkUiDatePicker.PrevTrigger>
      <ArkUiDatePicker.ViewTrigger asChild>
        <Button
          hierarchy="secondary-subtler"
          fullWidth
          disabled={datePicker.view === "year"}
        >
          <Text textStyle="title.s" className={classes.title}>
            {headerText(datePicker, translations)}
          </Text>
        </Button>
      </ArkUiDatePicker.ViewTrigger>
      <ArkUiDatePicker.NextTrigger asChild>
        <Button iconOnly hierarchy="secondary-subtle">
          <Icon name="chevron-right" />
        </Button>
      </ArkUiDatePicker.NextTrigger>
      {withDoubleArrows ? (
        <ArkUiDatePicker.NextTrigger asChild>
          <Button
            iconOnly
            hierarchy="secondary-subtle"
            onClick={(event) => {
              datePicker.focusYear(datePicker.focusedValue.year + 1);
              // prevent adding one month
              event.preventDefault();
            }}
          >
            <Icon name="chevron-right-double" />
          </Button>
        </ArkUiDatePicker.NextTrigger>
      ) : null}
    </ArkUiDatePicker.ViewControl>
  );
}

function headerText(
  datePicker: UseDatePickerContext,
  translations: Translations,
): string {
  switch (datePicker.view) {
    case "year":
      return translations.year;
    case "month":
      return datePicker.visibleRange.start.year.toString();
    case "day":
      return datePicker.visibleRangeText.start;
  }
}
